import { Map } from "leaflet";

import { useConfigParameters } from "hooks/configParametersHooks";

import { StudyAreaDrawerContent } from "components/studyArea/StudyAreaDrawerContent";
import { useParams } from "react-router-dom";
import { useStudyArea } from "hooks/studyAreaHooks";
import { useMeasureConfigs } from "hooks/measureConfigHooks";

interface Props {
  mapRef: Map;
  footerRef: HTMLDivElement;
}

export function LoadConfigParameters(props: Props) {
  const { mapRef, footerRef } = props;
  const { uuid } = useParams();
  const { data: configParameters } = useConfigParameters();
  const { data: studyArea } = useStudyArea(uuid || "", {
    enabled: !!uuid,
  });
  const { data: measureConfigs } = useMeasureConfigs(uuid || "", {
    enabled: !!uuid,
  });

  return (
    <>
      {configParameters && (
        <StudyAreaDrawerContent
          mapRef={mapRef}
          footerRef={footerRef}
          configParameters={configParameters}
          studyArea={studyArea}
          measureConfigs={measureConfigs || []}
          uuid={uuid}
        />
      )}
    </>
  );
}
